export const MIN_SIDEBAR_SIZE = 300;
